import gql from 'graphql-tag';

import { ConfluenceWorkspaceAri, IdentityUserAri } from '@atlassian/ari';

import { UNSAFE_expValEqualsNoExposure } from '@confluence/feature-experiments';
import { preloadSideNavigationOnboardingState } from '@confluence/onboarding-helpers/entry-points/preloadSideNavigationOnboardingState';
import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql';

import { preloadGlobalApps } from './GlobalItems/AppsItem/preloadGlobalApps';

export const preloadGlobalNavigationComponent = async () => {
	const { cloudId, userId, activationId } = getPreloaderFnContext();

	const promises: Promise<any>[] = [preloadGlobalApps()];

	if (userId) {
		promises.push(
			queryAgg({
				/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
				query: preloadGlobalNavigationComponentQuery,
				context: {
					headers: {
						'Atl-Client-Name': 'confluence-frontend',
					},
				},
				variables: {
					entityAri: ConfluenceWorkspaceAri.create({ siteId: cloudId, activationId }).toString(),
					ownerAri: IdentityUserAri.create({ userId }).toString(),
				},
			}),
		);
	}

	if (UNSAFE_expValEqualsNoExposure('cfind-4473-creation-focused-nav', 'cohort', 'treatment')) {
		promises.push(preloadSideNavigationOnboardingState());
	}

	return waitForAllReturnWhenError(promises);
};

const preloadGlobalNavigationComponentQuery = gql`
	query preloadGlobalNavigationComponentQuery($entityAri: ID!, $ownerAri: ID!) {
		settings_navigationCustomisation(entityAri: $entityAri, ownerAri: $ownerAri) {
			sidebar {
				nodes {
					menuId
					visible
				}
			}
		}
	}
`;
